import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// V4.8 RC48-ATT-001…004: actionable per-module badge counts for the dealer nav.
export function useDealerActionCounts() {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    let cancelled = false;
    const fetchCounts = () =>
      api
        .get("/dealer/action-counts")
        .then((res) => !cancelled && setCounts(res.data))
        .catch(() => {});
    fetchCounts();
    const t = setInterval(fetchCounts, 30000);
    const onChanged = () => fetchCounts();
    window.addEventListener("notifications:changed", onChanged);
    return () => {
      cancelled = true;
      clearInterval(t);
      window.removeEventListener("notifications:changed", onChanged);
    };
  }, []);

  return counts;
}
